import React, { useMemo, useState } from "react";
import { Tabs, Tab, Box } from "@material-ui/core";
import { FieldPermissionsGroupTab } from "./FieldPermissionsGroupTab";
import { useTranslate } from "react-admin";

interface FieldPermissionsTabProps {
  permissionDefinitions:
    | {
        [key: string]: {
          [key: string]: any;
        };
      }
    | null
    | undefined;
  isEdit?: boolean;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      <Box>{children}</Box>
    </div>
  );
};

export const InnerFieldPermissionsTab = ({
  permissionDefinitions,
  ...rest
}: FieldPermissionsTabProps) => {
  const translate = useTranslate();
  const [selectedTab, setSelectedTab] = useState(0);
  const handleChange = (_: React.ChangeEvent<{}>, newValue: number) => {
    setSelectedTab(newValue);
  };

  const tabs = useMemo(() => {
    if (!permissionDefinitions) {
      return null;
    }

    return Object.getOwnPropertyNames(permissionDefinitions).map(
      (permissionGroup) => {
        return (
          <Tab
            key={permissionGroup}
            label={translate(
              `permissions.fieldPermissions.${permissionGroup}.tabName`
            )}
          />
        );
      }
    );
  }, [permissionDefinitions, translate]);

  const tabPanels = useMemo(() => {
    if (!permissionDefinitions) {
      return null;
    }

    return Object.getOwnPropertyNames(permissionDefinitions).map(
      (permissionGroup, index) => {
        return (
          <TabPanel key={permissionGroup} value={selectedTab} index={index}>
            <FieldPermissionsGroupTab
              group={permissionDefinitions[permissionGroup]}
              groupName={permissionGroup}
              {...rest}
            />
          </TabPanel>
        );
      }
    );
  }, [permissionDefinitions, rest, selectedTab]);

  return (
    <>
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="on"
        indicatorColor="primary"
        textColor="primary">
        {tabs}
      </Tabs>
      {tabPanels}
    </>
  );
};
